module.exports = __webpack_public_path__ + "static/model-keycap-i-e94215cb88360a3a0b73f82c57848a5a.png";